export const APP_CONFIG = {
  URL: {
    apiBasePath: `${location.origin}/`,
  },
};

export const getHeaders = () => {
  return {
    "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  }
}


export const getTitle = () => {
  switch (window.location.host) {
    case 'oswin21.com':
    case 'localhost:8080':
      return 'OSWIN21';
    default:
      return '365';
  }
}

export const enablePrint = () => {
  switch (window.location.host) {
    case 'oswin21.com':
    case 'localhost:8080':
      return true;
    default:
      return false;
  }
}


export const enableTableTimeline = () => {
  switch (window.location.host) {
    case 'oswin21.com':
    case 'localhost:8080':
      return true;
    default:
      return false;
  }
}